import LightLevelIcon from './component'

export default LightLevelIcon
